import {
  brandSpecificStaticText,
  staticText,
  Translated,
} from '../../utils/translations/staticText';

// Block ships only on SingSaver (SG, EN) and MoneyHero (HK, EN + ZH-HK) per
// CMS-1639. SingSaver has no ZH locale, so the default (`_`) covers it;
// MoneyHero overlays ZH on top of the same English defaults.
export const TRANSLATIONS = brandSpecificStaticText({
  _: staticText({
    see_more: { _: 'See more' },
    see_less: { _: 'See less' },
    copy: { _: 'Copy' },
    copied: { _: 'Copied ✓' },
    promo_label: { _: 'Promo:' },
  }),
  moneyhero: staticText({
    see_more: { _: 'See more', zh: '更多資訊' },
    see_less: { _: 'See less', zh: '更少資訊' },
    copy: { _: 'Copy', zh: '複製' },
    copied: { _: 'Copied ✓', zh: '已複製 ✓' },
    promo_label: { _: 'Promo:', zh: '促銷:' },
  }),
});

export type StaticText = Translated<typeof TRANSLATIONS>;
